
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Form as elForm } from "element-ui";
import Wenjian from "@/components/wenjian.vue";
const cityData = require("@/assets/pca-code.json");
import { patientDetail, getDiseases, editPatient } from "@/request/doctor";
@Component({
  components: {
    Wenjian,
  },
})
export default class Name extends Vue {
  @Prop()
  private id: any;
  @Watch("id", { immediate: true })
  private idChange() {
    console.log("3333");
    console.log(this.id);
    this.getData();
  }
  private disabledStartDate: any = this.endDate();
  private ifView: boolean = false;
  private cityOption: any;
  private diseases: any = [];
  private data: any = {
    姓名: "",
    身份证号: "",
    手机号: "",
    性别: "",
    出生日期: "",
    疾病: [],
    现居住在: "",
    现居住地区: "",
    地址: [],
    详细地址: "",
    紧急联系人: "",
    紧急联系人电话: "",
  };
  private rules: any = {
    姓名: [{ required: true, message: "请填写姓名", trigger: "blur" }],
    身份证号: [{ validator: this.checkIdcard, trigger: "blur" }],
    手机号: [{ validator: this.checkPhone, trigger: "blur" }],
    性别: [{ required: true, message: "请选择性别", trigger: "blur" }],
    出生日期: [{ required: true, message: "请选择出生日期", trigger: "blur" }],
    // 疾病: [{ required: true, message: "请选择疾病", trigger: "blur" }],
    现居住在: [{ required: true }],
    现居住地区: [{ required: true }],
    地址: [{ required: false, message: "请选择地址", trigger: "blur" }],
    紧急联系人电话: [{ validator: this.checkPhone2, trigger: "blur" }],
  };

  private get user() {
    return this.$store.state.user || {};
  }
  private endDate() {
    const self = this;
    return {
      disabledDate(time: any) {
        return time.getTime() > Date.now();
      },
    };
  }
  private checkPhone(rule: any, value: any, callback: any) {
    if (!value) {
      return callback(new Error("请填写手机号"));
    } else {
      const reg = /^\d{11}$/;
      if (!reg.test(value)) {
        callback(new Error("手机号必须为11位数字"));
      }
    }
    callback();
  }
  private checkPhone2(rule: any, value: any, callback: any) {
    if (value) {
      const reg = /^\d{11}$/;
      if (!reg.test(value)) {
        callback(new Error("紧急联系人电话必须为11位数字"));
      }
    }
    callback();
  }
  private checkIdcard(rule: any, value: any, callback: any) {
    if (!value) {
      return callback(new Error("请填写身份证号"));
    } else {
      const reg = /^[a-zA-Z0-9]{18}$/;
      if (!reg.test(value)) {
        callback(new Error("身份证号必须为18位数字或字母"));
      }
    }
    callback();
  }
  private checkManbing(rule: any, value: any, callback: any) {
    if (!value || value.length === 0) {
      return callback(new Error("请选择疾病"));
    }
    callback();
  }
  private isChecked(item: any) {
    if (!this.data["疾病"] || this.data["疾病"].length === 0) {
      return false;
    }
    let result: any = [];
    let rel = false;
    this.data["疾病"].forEach((ele: any) => {
      result.push(ele["名称"]);
    });
    if (result.indexOf(item) !== -1) {
      rel = true;
    } else {
      rel = false;
    }
    return rel;
  }
  private diseasesChange(item: any) {
    item.checked = !item.checked;
    this.data["疾病"] = [];
    this.diseases.forEach((ele: any) => {
      if (ele.checked) {
        this.data["疾病"].push(ele);
      }
    });
  }
  private save() {
    (this.$refs["myForm"] as elForm).validate((isValid: boolean) => {
      console.log(isValid);
      if (isValid) {
        this.data.source = "pc管理";
        editPatient(this, this.data).then((res: any) => {
          this.$message.success("保存成功");
        });
      }
    });
  }
  private getData() {
    if (!this.id) {
      this.data = {};
      return;
    }
    const params = {
      patient_id: this.id,
      source: "pc医生",
    };
    patientDetail(this, params).then((res) => {
      this.data = res;
      this.$store.commit("updatePatient", res);
      this.getDiseases();
    });
  }
  private getDiseases() {
    getDiseases(this).then((res: any) => {
      res.forEach((element: any) => {
        element.checked = false;
      });
      res.forEach((element: any) => {
        this.data["疾病"].forEach((ele: any) => {
          if (element.disease_id === ele.disease_id) {
            element.checked = true;
          }
        });
      });
      this.diseases = res;
    });
  }
  /**
   * @description 加载三级联动数据，加载缓存的验证码等待时间
   */
  private beforeMount() {
    this.cityOption = cityData;
  }
  private updateBingshi(d: any) {
    this.data["病史资料"] = d;
  }
  mounted() {
    // this.getData();
  }
}
